import { createFileRoute } from "@tanstack/react-router";
import { IntegrationDetail } from "@/pages/IntegrationDetail";
import { integrationPages } from "@/lib/integration-pages";
import { buildHead } from "@/lib/seo-head";

const page = integrationPages["webmotors"];
if (!page) throw new Error("Integração não cadastrada");

export const Route = createFileRoute("/estoque-veiculos-ia-webmotors")({
  head: () => buildHead({
    title: page.metaTitle,
    description: page.metaDescription,
    path: "/estoque-veiculos-ia-webmotors",
  }),
  component: () => <IntegrationDetail integrationKey="webmotors" />,
});
